import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'

const useUpdateScannerSteps = (scannerId?: string) => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async (steps: string[]) => {
      if (!accountId || !scannerId) {
        return
      }

      return accountsService.updateScannerSteps(scannerId, accountId, steps)
    },
    {
      onSuccess: (data, vars) => {
        if (!data) return

        queryClient.invalidateQueries([QUERY_KEYS.STEPS, accountId, { query: '' }])
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_USERS, accountId])
      },
    },
  )
}

export { useUpdateScannerSteps }
